<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-power-structure-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-power-structure-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.37542662116041;"
    data-aspect-ratio="0.375"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-power-structure-xs-img"
      class="g-power-structure-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/power-structure-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.2959%;margin-top:-9.1px;left:3.7244%;width:65px;"
    >
      <p class="g-pstyle1">Advises</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.2515%;margin-top:-17.5px;right:4.1026%;width:96px;"
    >
      <p class="g-pstyle2">Appoints</p>
      <p class="g-pstyle2">and oversees</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.2868%;margin-top:-8.6px;left:45.5896%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle3">Ali Khamenei</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.2208%;margin-top:-8.6px;left:45.4881%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle4">Supreme Leader</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:21.5109%;margin-top:-9.1px;left:78.8475%;width:73px;"
    >
      <p class="g-pstyle1">Appoints</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:26.2228%;margin-top:-7.5px;left:19.2174%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle5">ARMED FORCES</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:26.2228%;margin-top:-7.5px;left:75.2579%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle5">JUDICIARY</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:29.9751%;margin-top:-17.5px;left:75.7441%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle6">Includes a Supreme</p>
      <p class="g-pstyle6">Court and lower courts</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-artwork g-aiAbs"
      style="top:37.6434%;margin-top:-22.9px;left:35.8092%;margin-left:-15.303%;width:30.6061%;"
    >
      <p class="g-pstyle7">ISLAMIC REVOLUTIONARY GUARD CORPS</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-artwork g-aiAbs"
      style="top:36.1775%;right:26.0007%;width:16.3636%;"
    >
      <p class="g-pstyle8">Suggests jurists</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-artwork g-aiAbs"
      style="top:44.5447%;margin-top:-14.5px;left:18.8248%;margin-left:-10.303%;width:20.6061%;"
    >
      <p class="g-pstyle7">REGULAR MILITARY</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-artwork g-aiAbs"
      style="top:44.8237%;left:75%;margin-left:-11.0606%;width:22.1212%;"
    >
      <p class="g-pstyle9">Guardian Council</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:51.3783%;margin-top:-17.6px;left:75.79%;margin-left:-48.5px;width:97px;"
    >
      <p class="g-pstyle6">6 clerics and</p>
      <p class="g-pstyle6">6 jurists</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:58.8716%;margin-top:-17.5px;right:6.0838%;width:75px;"
    >
      <p class="g-pstyle2">Approves</p>
      <p class="g-pstyle2">jurists</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:58.8261%;margin-top:-9.1px;right:27.0335%;width:73px;"
    >
      <p class="g-pstyle10">Appoints</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-artwork g-aiAbs"
      style="top:59.7918%;margin-top:-15.6px;left:20.6559%;margin-left:-17.5758%;width:35.1515%;"
    >
      <p class="g-pstyle7">SUPREME NATIONAL SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.9034%;margin-top:-9.1px;left:48.5377%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle11">Appoints</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:75.6065%;margin-top:-8.6px;left:21.6106%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle3">Ali Ardashi Larijani</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:75.6065%;margin-top:-8.6px;left:75.0114%;margin-left:-69px;width:138px;"
    >
      <p class="g-pstyle3">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:77.6543%;margin-top:-8.6px;left:21.665%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle4">Secretary</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:77.6543%;margin-top:-8.6px;left:74.9652%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle4">President</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:79.5314%;margin-top:-9.1px;left:74.7368%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle11">(Elected)</p>
    </div>
    <div
      id="g-ai0-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:86.7688%;margin-top:-14.7px;left:59.7794%;margin-left:-49.5px;width:99px;"
    >
      <p class="g-pstyle12">Assembly of</p>
      <p class="g-pstyle12">experts</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:86.6986%;margin-top:-9.1px;right:62.0012%;width:73px;"
    >
      <p class="g-pstyle10">(Elected)</p>
    </div>
    <div
      id="g-ai0-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.9137%;margin-top:-9.1px;right:62.0012%;width:73px;"
    >
      <p class="g-pstyle10">(Elected)</p>
    </div>
    <div
      id="g-ai0-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.8473%;margin-top:-7.5px;left:59.7918%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle12">Parliament</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:7.6942%;margin-top:-8.6px;left:65.7462%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-power-structure-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.67460317460317;"
    data-aspect-ratio="0.675"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-power-structure-sm-img"
      class="g-power-structure-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/power-structure-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.2964%;margin-top:-9.1px;left:4.5871%;width:65px;"
    >
      <p class="g-pstyle1">Advises</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.4075%;margin-top:-17.5px;right:3.4187%;width:96px;"
    >
      <p class="g-pstyle2">Appoints</p>
      <p class="g-pstyle2">and oversees</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.6113%;margin-top:-8.6px;left:47.7547%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle3">Ali Khamenei</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:18.8599%;margin-top:-8.6px;left:47.689%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle4">Supreme Leader</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.0107%;margin-top:-9.1px;left:69.2745%;width:73px;"
    >
      <p class="g-pstyle1">Appoints</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.4892%;margin-top:-7.5px;left:28.7296%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle5">ARMED FORCES</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.4892%;margin-top:-7.5px;left:66.9518%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle5">JUDICIARY</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.852%;margin-top:-17.5px;left:67.262%;margin-left:-85px;width:170px;"
    >
      <p class="g-pstyle6">Includes a Supreme Court</p>
      <p class="g-pstyle6">and lower courts</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:39.9578%;margin-top:-9.1px;left:69.2747%;width:112px;"
    >
      <p class="g-pstyle7">Suggests jurists</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-artwork g-aiAbs"
      style="top:43.7679%;margin-top:-22.9px;left:39.4655%;margin-left:-9.902%;width:19.8039%;"
    >
      <p class="g-pstyle8">ISLAMIC REVOLUTIONARY GUARD CORPS</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-artwork g-aiAbs"
      style="top:42.9296%;margin-top:-14.5px;left:15.3172%;margin-left:-6.6667%;width:13.3333%;"
    >
      <p class="g-pstyle8">REGULAR MILITARY</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:45.8594%;margin-top:-7.7px;left:66.9623%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle9">Guardian Council</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:49.2456%;margin-top:-9.3px;left:67.3089%;margin-left:-71px;width:142px;"
    >
      <p class="g-pstyle6">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-artwork g-aiAbs"
      style="top:53.7791%;margin-top:-15.6px;left:16.9153%;margin-left:-11.3725%;width:22.7451%;"
    >
      <p class="g-pstyle8">SUPREME NATIONAL SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:53.8467%;margin-top:-9.1px;left:69.2745%;width:73px;"
    >
      <p class="g-pstyle1">Appoints</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:61.9155%;margin-top:-9.1px;left:42.4073%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle10">Appoints</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.2012%;margin-top:-17.5px;left:86.6728%;width:76px;"
    >
      <p class="g-pstyle11">Approves</p>
      <p class="g-pstyle11">jurists</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.0345%;margin-top:-8.6px;left:16.5526%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle3">Ali Ardashi Larijani</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.0345%;margin-top:-8.6px;left:66.7923%;margin-left:-69px;width:138px;"
    >
      <p class="g-pstyle3">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.4155%;margin-top:-8.6px;left:16.5879%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle4">Secretary</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.4155%;margin-top:-8.6px;left:66.7624%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle4">President</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:76.598%;margin-top:-9.1px;left:66.6146%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle10">(Elected)</p>
    </div>
    <div
      id="g-ai1-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.6902%;margin-top:-14.7px;left:66.7402%;margin-left:-49.5px;width:99px;"
    >
      <p class="g-pstyle9">Assembly of</p>
      <p class="g-pstyle9">experts</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.6086%;margin-top:-9.1px;right:47.3531%;width:73px;"
    >
      <p class="g-pstyle12">(Elected)</p>
    </div>
    <div
      id="g-ai1-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.3229%;margin-top:-9.1px;right:47.3531%;width:73px;"
    >
      <p class="g-pstyle12">(Elected)</p>
    </div>
    <div
      id="g-ai1-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.2458%;margin-top:-7.5px;left:66.7482%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle9">Parliament</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.946%;margin-top:-8.6px;left:60.7971%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-power-structure-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.87649402390438;"
    data-aspect-ratio="0.876"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-power-structure-md-img"
      class="g-power-structure-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/power-structure-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.6774%;margin-top:-8.6px;left:48.72%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:18.9351%;margin-top:-8.6px;left:48.6692%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle2">Supreme Leader</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.1104%;margin-top:-9.1px;left:65.3489%;width:73px;"
    >
      <p class="g-pstyle3">Appoints</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.6106%;margin-top:-7.5px;left:34.0187%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle4">ARMED FORCES</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.6106%;margin-top:-7.5px;left:63.5541%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle4">JUDICIARY</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.2113%;margin-top:-9.1px;left:7.4636%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle5">Advises</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.9908%;margin-top:-17.5px;left:63.7938%;margin-left:-85px;width:170px;"
    >
      <p class="g-pstyle6">Includes a Supreme Court</p>
      <p class="g-pstyle6">and lower courts</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:40.117%;margin-top:-9.1px;left:65.349%;width:112px;"
    >
      <p class="g-pstyle7">Suggests jurists</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-artwork g-aiAbs"
      style="top:43.9423%;margin-top:-22.9px;left:42.3146%;margin-left:-7.6515%;width:15.303%;"
    >
      <p class="g-pstyle8">ISLAMIC REVOLUTIONARY GUARD CORPS</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-artwork g-aiAbs"
      style="top:43.1006%;margin-top:-14.5px;left:23.6546%;margin-left:-5.1515%;width:10.303%;"
    >
      <p class="g-pstyle8">REGULAR MILITARY</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:44.5526%;margin-top:-17.5px;left:88.1359%;width:96px;"
    >
      <p class="g-pstyle9">Appoints</p>
      <p class="g-pstyle9">and oversees</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.0421%;margin-top:-7.7px;left:63.5622%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle10">Guardian Council</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:49.4418%;margin-top:-9.3px;left:63.83%;margin-left:-71px;width:142px;"
    >
      <p class="g-pstyle6">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs"
      style="top:53.9934%;margin-top:-15.6px;left:11.2531%;margin-left:-8.7879%;width:17.5758%;"
    >
      <p class="g-pstyle8">SUPREME NATIONAL SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:54.0612%;margin-top:-9.1px;left:65.3489%;width:73px;"
    >
      <p class="g-pstyle3">Appoints</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:62.1622%;margin-top:-9.1px;left:37.6182%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">Appoints</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.4649%;margin-top:-17.5px;left:78.7931%;width:76px;"
    >
      <p class="g-pstyle9">Approves</p>
      <p class="g-pstyle9">jurists</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.3215%;margin-top:-8.6px;left:10.9729%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle1">Ali Ardashi Larijani</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.3215%;margin-top:-8.6px;left:63.4308%;margin-left:-69px;width:138px;"
    >
      <p class="g-pstyle1">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.712%;margin-top:-8.6px;left:11.0001%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle2">Secretary</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.712%;margin-top:-8.6px;left:63.4078%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle2">President</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:76.9032%;margin-top:-9.1px;left:63.2935%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">(Elected)</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:84.0236%;margin-top:-14.7px;left:63.3906%;margin-left:-49.5px;width:99px;"
    >
      <p class="g-pstyle10">Assembly of</p>
      <p class="g-pstyle10">experts</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.9417%;margin-top:-9.1px;right:47.4997%;width:73px;"
    >
      <p class="g-pstyle11">(Elected)</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6987%;margin-top:-9.1px;right:47.4997%;width:73px;"
    >
      <p class="g-pstyle11">(Elected)</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.6213%;margin-top:-7.5px;left:63.3968%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle10">Parliament</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.9817%;margin-top:-8.6px;left:58.7982%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-power-structure-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.07763615295481;"
    data-aspect-ratio="1.078"
    data-min-width="930"
  >
    <div
      id="g-power-structure-lg-img"
      class="g-power-structure-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/power-structure-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.9947%;margin-top:-9.7px;left:49.2339%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle1">Ali Khamenei</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.3122%;margin-top:-9.7px;left:49.2464%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle2">Supreme Leader</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:25.5598%;margin-top:-9.6px;left:62.638%;width:73px;"
    >
      <p class="g-pstyle3">Appoints</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.89%;margin-top:-8.6px;left:37.4332%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle4">ARMED FORCES</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.89%;margin-top:-8.6px;left:61.1658%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle4">JUDICIARY</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.5552%;margin-top:-9.6px;left:16.0068%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle5">Advises</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:35.0499%;margin-top:-17.5px;left:61.3841%;margin-left:-85px;width:170px;"
    >
      <p class="g-pstyle6">Includes a Supreme Court</p>
      <p class="g-pstyle6">and lower courts</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:40.3918%;margin-top:-4.6px;left:62.638%;width:112px;"
    >
      <p class="g-pstyle7">Suggests jurists</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-artwork g-aiAbs"
      style="top:41.3673%;left:44.1036%;margin-left:-5.5914%;width:11.1828%;"
    >
      <p class="g-pstyle8">ISLAMIC</p>
      <p class="g-pstyle8">REVOLUTIONARY</p>
      <p class="g-pstyle8">GUARD CORPS</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-artwork g-aiAbs"
      style="top:41.5991%;left:29.04%;margin-left:-3.1183%;width:6.2366%;"
    >
      <p class="g-pstyle8">REGULAR</p>
      <p class="g-pstyle8">MILITARY</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:44.5517%;margin-top:-17.5px;left:81.4837%;width:96px;"
    >
      <p class="g-pstyle9">Appoints</p>
      <p class="g-pstyle9">and oversees</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.1545%;margin-top:-9.3px;left:61.1725%;margin-left:-75.5px;width:151px;"
    >
      <p class="g-pstyle10">Guardian Council</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:49.6288%;margin-top:-9.3px;left:61.4109%;margin-left:-71px;width:142px;"
    >
      <p class="g-pstyle6">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-artwork g-aiAbs"
      style="top:52.2596%;left:19.0498%;margin-left:-6.7742%;width:13.5484%;"
    >
      <p class="g-pstyle8">SUPREME NATIONAL</p>
      <p class="g-pstyle8">SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:54.1809%;margin-top:-9.6px;left:62.638%;width:73px;"
    >
      <p class="g-pstyle3">Appoints</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:62.1763%;margin-top:-9.6px;left:40.3006%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">Appoints</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:66.2203%;margin-top:-17.5px;left:73.4756%;width:76px;"
    >
      <p class="g-pstyle9">Approves</p>
      <p class="g-pstyle9">jurists</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.1511%;margin-top:-9.7px;left:18.8471%;margin-left:-74px;width:148px;"
    >
      <p class="g-pstyle1">Ali Ardashi Larijani</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:72.1511%;margin-top:-9.7px;left:61.0621%;margin-left:-77px;width:154px;"
    >
      <p class="g-pstyle1">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.4686%;margin-top:-9.7px;left:18.8385%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle2">Secretary</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.4686%;margin-top:-9.7px;left:61.0588%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle2">President</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:76.7765%;margin-top:-9.6px;left:60.9803%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle5">(Elected)</p>
    </div>
    <div
      id="g-ai3-24"
      class="g-artwork g-aiAbs"
      style="top:81.8076%;left:61.0872%;margin-left:-6.6667%;width:13.3333%;"
    >
      <p class="g-pstyle11">Assembly of experts</p>
    </div>
    <div
      id="g-ai3-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.729%;margin-top:-9.6px;right:47.7165%;width:73px;"
    >
      <p class="g-pstyle12">(Elected)</p>
    </div>
    <div
      id="g-ai3-26"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.3315%;margin-top:-9.1px;left:61.0737%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle10">Parliament</p>
    </div>
    <div
      id="g-ai3-27"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.3895%;margin-top:-9.6px;right:47.7165%;width:73px;"
    >
      <p class="g-pstyle12">(Elected)</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:9.4628%;margin-top:-9.7px;left:57.375%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle0">Killed</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-02 15:48 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-02 15:48 -->
<!-- ai file: power-structure.ai -->
<style lang="scss">
  #g-power-structure-box {
    container-type: inline-size;
    container-name: g-power-structure-box;
  }
  #g-power-structure-box,
  #g-power-structure-box .g-artboard {
    margin: 0 auto;
  }
  #g-power-structure-box p {
    margin: 0;
  }
  #g-power-structure-box .g-aiAbs {
    position: absolute;
  }
  #g-power-structure-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-power-structure-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-power-structure-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-power-structure-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-power-structure-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-power-structure-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-power-structure-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-power-structure-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-power-structure-lg {
        display: block !important;
      }
    }
  }
  #g-power-structure-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-power-structure-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-power-structure-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-power-structure-xs .g-pstyle1 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-xs .g-pstyle2 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: right;
  }
  #g-power-structure-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-xs .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-xs .g-pstyle5 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 8px;
    text-align: center;
  }
  #g-power-structure-xs .g-pstyle6 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-power-structure-xs .g-pstyle7 {
    font-weight: 700;
    padding-bottom: 8px;
    text-align: center;
  }
  #g-power-structure-xs .g-pstyle8 {
    font-weight: 300;
    line-height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: right;
  }
  #g-power-structure-xs .g-pstyle9 {
    font-weight: 500;
    padding-bottom: 8px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-power-structure-xs .g-pstyle10 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-xs .g-pstyle11 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-xs .g-pstyle12 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 8px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-power-structure-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-power-structure-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-power-structure-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-power-structure-sm .g-pstyle1 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-sm .g-pstyle2 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: right;
  }
  #g-power-structure-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-sm .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-sm .g-pstyle5 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 8px;
    text-align: center;
  }
  #g-power-structure-sm .g-pstyle6 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-power-structure-sm .g-pstyle7 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
  }
  #g-power-structure-sm .g-pstyle8 {
    font-weight: 700;
    padding-bottom: 8px;
    text-align: center;
  }
  #g-power-structure-sm .g-pstyle9 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 8px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-power-structure-sm .g-pstyle10 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-sm .g-pstyle11 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-power-structure-sm .g-pstyle12 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-power-structure-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-power-structure-md .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-power-structure-md .g-pstyle1 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-md .g-pstyle2 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-md .g-pstyle3 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-md .g-pstyle4 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 8px;
    text-align: center;
  }
  #g-power-structure-md .g-pstyle5 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-md .g-pstyle6 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-power-structure-md .g-pstyle7 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
  }
  #g-power-structure-md .g-pstyle8 {
    font-weight: 700;
    padding-bottom: 8px;
    text-align: center;
  }
  #g-power-structure-md .g-pstyle9 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-power-structure-md .g-pstyle10 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 8px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-power-structure-md .g-pstyle11 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-power-structure-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 10px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-power-structure-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-power-structure-lg .g-pstyle1 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-lg .g-pstyle2 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-lg .g-pstyle3 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-lg .g-pstyle4 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
  }
  #g-power-structure-lg .g-pstyle5 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-power-structure-lg .g-pstyle6 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
  }
  #g-power-structure-lg .g-pstyle7 {
    font-weight: 300;
    line-height: 8px;
    height: 8px;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-power-structure-lg .g-pstyle8 {
    font-weight: 700;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-power-structure-lg .g-pstyle9 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-power-structure-lg .g-pstyle10 {
    font-weight: 500;
    line-height: 17px;
    height: 17px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-power-structure-lg .g-pstyle11 {
    font-weight: 500;
    line-height: 17px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-power-structure-lg .g-pstyle12 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: right;
    color: rgb(64, 64, 64);
  }

  /* Custom CSS */
</style>
